<template>
    <UContainer class="min-h-screen-with-header pt-4 lg:pt-12">
        <UDivider>
            <UiComponentTypography tag="h1" class-name="shrink-0">دسته‌بندی‌ها</UiComponentTypography>
        </UDivider>
        <div v-if="status === 'pending'">
            <div v-for="i in 3" class="flex gap-2 bg-white p-6 rounded-md shadow my-4">
                <USkeleton class="w-6 h-6" />
                <USkeleton class="w-full h-6" />
            </div>
        </div>
        <ul class="mt-6 flex justify-center flex-wrap">
            <li class="p-2 lg:p-4 w-1/2 md:w-1/4 lg:w-1/6 lg:min-w-72 max-lg:min-h-full" v-for="item in list">
                <div class="bg-white p-4 rounded-md shadow my-4 max-lg:min-h-full">
                    <h3 class="peer p-2 hover:bg-amazon-50 rounded-sm transition-all max-lg:text-center">
                        <NuxtLink :to="`/category/${item?.slug}`" class="flex flex-col items-center gap-2">
                            <UtilsDynamicIcon
                                v-if="item?.icon"
                                :icon="item?.icon"
                                class-name="block w-full min-h-min aspect-square fill-gray-400 text-gray-400 px-4"
                            />
                            <span>
                                {{ item?.name }}
                            </span>
                            <UButton
                                v-if="item?.children"
                                :padded="false"
                                icon="i-solar-alt-arrow-down-outline"
                                variant="link"
                                color="black"
                            />
                        </NuxtLink>
                    </h3>
                </div>
            </li>
        </ul>
    </UContainer>
</template>

<script lang="ts" setup>
import type { ICategory } from "~/libs/types/api/category";

useSeoMeta({
    title: "دسته‌بندی محصولات | فروشگاه رستری قهوه نرس‌لند",
    description: "مشاهده و خرید آنلاین انواع دان و پودر قهوه تخصصی، تجاری، قهوه دمی، اسپرسو، پودرهای فوری و ملزومات دم‌آوری قهوه در فروشگاه نرس‌لند.",
    canonical: "https://northland-co.com/category",
    ogTitle: "دسته‌بندی محصولات قهوه نرس‌لند",
    ogDescription: "مشاهده و خرید انواع قهوه و لوازم جانبی در فروشگاه تخصصی نرس‌لند.",
    ogType: "website",
    ogUrl: "https://northland-co.com/category",
    robots: "index, follow",
});

useSchemaOrg([
    defineBreadcrumb({
        itemListElement: [
            { name: "خانه", item: "/" },
            { name: "دسته‌بندی‌ها", item: "/category" },
        ],
    }),
]);

defineOgImageComponent("Main", {
    title: "دسته‌بندی محصولات",
    description: "مشاهده و خرید آنلاین انواع قهوه تخصصی و تجاری",
    path: "/category",
});

const { data: list, status, error, refresh } = await useCategoryList<ICategory[]>();
</script>

<style></style>
